module.exports = __webpack_public_path__ + "static/media/ma.821b3239.svg";